export default {
    errorPage: {
        notFond: {
            security: 'Ouch',
            Default: 'Please check whether the URL you entered is correct, or click the button below to return to the home page',
            DefaultRules: 'Return to Home Page',
            Minlength: 'The administrator said that you cannot enter this page...',
        },
        errorInfo: {
            back: 'back',
            security: "You don't have permission to go to this page",
            Maxerrors: 'If you have any complaints, please contact your leader',
            MaxerrorsRules: 'Or you can go',
            Maxrecent: 'Back to home page',
            errorscode: 'Just take a look',
            verification: 'Click me to see the picture',
        }
    },
};
